module.exports = "/* .icon-calendar{\r\n    background-color: #222b76;\r\n    padding: 0px 5px;\r\n    border-radius: 2px;\r\n    color: white!important;\r\n} */"


//////////////////
// WEBPACK FOOTER
// ./src/app/frontend/modules/boxcontent-2/boxcontent-2.component.css
// module id = ./src/app/frontend/modules/boxcontent-2/boxcontent-2.component.css
// module chunks = frontend.module